<template>
  <div class="row">
    <div class="col">
      <!-- Location Name -->
      <div class="row">
        <div class="col-4">
          <span class="custom-label">Name:</span>
          <input type="text" class="form-control" v-model="firmName" @keyup="changed(true)" @change="changed(true)" />
        </div>
        <div class="col pt-4">
          <span class="custom-label">Account created on:</span>
          <span class="ms-2">{{ createdOn }}</span>

          <span v-if="!isCancelled" class="custom-label">, active?:</span>
          <span v-if="!isCancelled" class="ms-2">{{ active }}</span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="row">
          <div class="col-3">
            <span class="custom-label">Main Contact:</span>
            <span class="ms-2">{{ mainContact }}</span>
          </div>
          <div v-if="isTempPassword" class="col-3">
            <span class="custom-label">Temp Password:</span>
            <span class="ms-2">{{ tempPassword }}</span>
          </div>
        </div>
      </div>
      <div v-if="isShop && isAdmin" class="row mt-4">
        <div class="col-4">
          <div class="row">
            <div class="col">
              <z-select v-model="product" name="product" label="Product" :options="products" :disabled="isCancelled" @change="subscriptionChange" />
            </div>
            <div class="col mt-4 text-center">
              <span v-if="isCancelled" class="custom-cancelled">Cancelled</span>
              <button v-else class="btn btn-primary btn-sm" @click="subscriptionCancel">Cancel Subscription</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-2 text-center">
      <button class="btn btn-primary btn-sm" @click="pricing">Learn More About Pricing</button>
    </div>
    <div class="col-2 text-center">
      <button class="btn btn-primary btn-sm" @click="agreement">License Agreement</button>
    </div>
    <div class="col"></div>
  </div>
  <DialogPricing v-model="actionPricing" @closing="closeModal" />
  <DialogAgreement v-model="actionAgreement" @closing="closeModal" />
  <ConfirmDialog
    v-model="actionConfirm"
    :confirm-title="confirmDialogTitle"
    :confirm-action="confirmDialogAction"
    :confirm-question="confirmDialogQuestion"
    @closing="closeModal"
    @proceed="performConfirmation"
  />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
import { authStore } from '@/stores/auth'
import { onboardStore } from '@/stores/onboard'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ConfirmDialog from '@/components/utilities/elements/ConfirmDialog.vue'
import DialogAgreement from '@/components/marketing/DialogAgreement.vue'
import DialogPricing from '@/components/marketing/DialogPricing.vue'
import globals from '@/plugins/globals'
// import { Tooltip } from 'bootstrap'
export default {
  name: 'LocationProfile',
  components: {
    ZSelect,
    ConfirmDialog,
    DialogAgreement,
    DialogPricing
  },
  props: {
    parent: Object,
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  emits: ['message', 'changed', 'saved', 'moved'],
  data() {
    return {
      previousProduct: null,
      confirmTask: null,
      actionConfirm: null,
      confirmDialogTitle: 'Confirm Subscription Cancellation',
      confirmDialogAction: 'Cancel Subscription',
      confirmDialogQuestion: 'Are you sure you wish to cancel this subscription?',
      actionPricing: false,
      actionAgreement: false
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(locationStore, ['loading', 'location']),
    ...mapState(onboardStore, ['products']),
    isLoading() {
      let _is = false
      if (this.loading) {
        _is = this.loading.users || this.loading.locations
      }
      return _is
    },
    isAdmin() {
      let _is = false
      if ([13].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isShop() {
      let _is = false
      if ([13, 14].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    firmName: {
      get() {
        let _data = null
        if (this.location) {
          _data = this.location.firmName
        }
        return _data
      },
      set(value) {
        this.setLocation({
          name: 'firmName',
          value: value
        })
      }
    },
    mainContact() {
      let _data = null
      if (this.location) {
        _data = this.location.mainContact
      }
      return _data
    },
    isTempPassword() {
      let _is = false
      if (this.location) {
        if (this.location.tempPassword !== null) {
          _is = true
        }
      }
      return _is
    },
    tempPassword() {
      let _data = null
      if (this.location) {
        _data = this.location.tempPassword
      }
      return _data
    },
    createdOn() {
      let _data = null
      if (this.location) {
        _data = globals.formatDate(this.location.createdOn)
      }
      return _data
    },
    active() {
      let _data = 'Yes'
      if (this.location) {
        if (this.location.isInactive) {
          _data = 'No'
        }
      }
      return _data
    },
    isCancelled() {
      let _is = false
      if (this.location) {
        _is = this.location.isCancelled
      }
      return _is
    },
    product: {
      get() {
        let _data = null
        if (this.location) {
          _data = this.location.product
        }
        return _data
      },
      set(value) {
        this.setLocation({
          name: 'product',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapState(authStore, ['setData']),
    ...mapActions(locationStore, ['setLocation', 'getLocation', 'saveLocation']),
    ...mapActions(onboardStore, ['changeSubscription', 'cancelSubscription']),
    init() {
      setTimeout(() => {
        this.previousProduct = this.product
      }, 250)
    },
    closeModal() {
      if (this.confirmTask === 'changeSubscription') {
        this.setLocation({
          name: 'product',
          value: this.previousProduct
        })
      }
      this.actionConfirm = null
      this.actionCancel = null
      this.actionPricing = null
      this.actionAgreement = null
    },
    changed(is) {
      this.$emit('changed', is)
    },
    cancel() {
      this.actionCancel = true
    },
    pricing() {
      this.actionPricing = {
        title: 'Invoices AI Pricing'
      }
    },
    agreement() {
      this.actionAgreement = {
        title: 'Software License Agreement'
      }
    },
    subscriptionChange() {
      if (this.isCancelled) {
        this.$emit('message', 'Subscription is cancelled. Please contact support to change your subscription.')
        return
      }
      this.confirmTask = 'changeSubscription'
      this.confirmDialogTitle = 'Confirm Subscription Change'
      this.confirmDialogAction = 'CHANGE Subscription'
      this.confirmDialogQuestion = `Are you sure you wish to CHANGE this subscription to ${this.product}?`
      this.actionConfirm = true
    },
    subscriptionCancel() {
      this.confirmTask = 'cancelSubscription'
      this.confirmDialogTitle = 'Confirm Subscription Cancellation'
      this.confirmDialogAction = 'CANCEL Subscription'
      this.confirmDialogQuestion = 'Are you sure you wish to CANCEL this subscription? THIS CANNOT BE UNDONE!'
      this.actionConfirm = true
    },
    async performConfirmation() {
      this.actionConfirm = null
      if (this.confirmTask === 'cancelSubscription') {
        let data = {
          firm: this.location.firm,
          testMode: false
        }
        console.log('Cancel Subscription', data)
        await this.cancelSubscription(data)
        this.setLocation({
          name: 'isCancelled',
          value: true
        })
        this.setData({
          name: 'isCancelled',
          value: true
        })
        await this.getLocation(this.profile.firm)
      } else if (this.confirmTask === 'changeSubscription') {
        let data = {
          firm: this.location.firm,
          product: this.location.product
        }
        console.log('Change Subscription', data)
        await this.changeSubscription(data)
        this.setData({
          name: 'product',
          value: this.location.product
        })
        await this.getLocation(this.profile.firm)
      }
      this.confirmTask = null
      this.closeModal()
    },
    async save() {
      let response = {
        valid: false,
        firm: null,
        msg: null
      }
      try {
        let valid = true
        if (this.firmName === null || this.firmName === '') {
          valid = false
        }
        if (valid) {
          console.log('Save Location', this.location)
          let result = await this.saveLocation()
          response.valid = true
          response.firm = result
          this.$emit('saved', result)
        } else {
          let msg = 'Location Not Valid'
          response.msg = msg
          this.$emit('message', msg)
        }
      } catch (e) {
        console.error(e)
        response.msg = 'Error: Unable to save'
        this.message = response.msg
      }
      return response
    }
  }
}
</script>
<style lang="scss">
.custom-inactive {
  position: relative;
  display: inline-flex;
  div {
    color: #0a58ca;
    margin-left: 5px;
    top: -5px;
  }
}
.custom-inactive-check {
  margin-top: 30px;
}
.custom-info {
  position: absolute;
  top: 0;
  right: 20px;
  color: #0a58ca;
}
.custom-label {
  font-weight: 500;
}
.custom-cancelled {
  color: red;
  font-weight: 500;
}
</style>
